<template>
  <div class="pdf-document">
    <PDFViewer
      v-if="pdf"
      :pdf-document="pdf"
      :show-form-fields="showFormFields"
      @page-rendered="pageRendered"
      @scroll="$emit('scroll')"
    />
  </div>
</template>

<script>
import PDFViewer from '@/components/pdf-viewer/PDFViewer';

import { mapGetters } from 'vuex';

export default {
  name: 'PDFDocument',
  components: {
    PDFViewer,
  },
  props: {
    showFormFields: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('pdfData', ['pdf']),
  },
  methods: {
    pageRendered(page) {
      this.$emit('page-rendered', page);
    },
  },
};
</script>

<style lang="scss">
.pdf-document {
  position: relative;
  height: 100%;
  width: 100%;
}
</style>
